import React, { useCallback, useState } from 'react'
import { twMerge } from 'tailwind-merge'
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline'

import { Button, Input } from 'ui-v2'
import { ApiError } from 'api/types/ApiError'
import { GetDemoRequestParams } from 'api/demoLinks/getDemos'
import useSubmitOnEnter from 'hooks/useSubmitOnEnter'

interface ParamsProps {
  onFiltersChange: (values: GetDemoRequestParams) => void
  error: ApiError | null
  isLoading?: boolean
}

const Params = ({ error, onFiltersChange, isLoading }: ParamsProps) => {
  const [hotelName, setHotelName] = useState<string>('')
  const [name, setName] = useState<string>('')

  const handleSearch = useCallback(() => {
    onFiltersChange({ hotel: hotelName, name })
  }, [onFiltersChange, hotelName, name])

  useSubmitOnEnter(handleSearch)

  return (
    <>
      <div className="p-4 bg-bg-accent-7 flex flex-col gap-3 md:px-7 lg:flex-row lg:items-start">
        <div className="lg:hidden">
          <div className="flex items-start justify-between gap-2 mb-2">
            <Input
              className="w-28"
              label="Hotel Name"
              value={hotelName}
              onChange={(value) => setHotelName(value || '')}
              error={error?.errors?.hotel}
            />

            <Input
              className="flex-1"
              label="Trial Name"
              value={name}
              onChange={(value) => setName(value || '')}
              error={error?.errors?.name}
            />

            <Button
              isLoading={isLoading}
              className="w-10 rounded p-0 flex items-center justify-center"
              onClick={handleSearch}
              size="large"
              variant="primary"
            >
              <MagnifyingGlassIcon className="text-white w-5" />
            </Button>
          </div>
        </div>

        <Input
          className="hidden lg:block lg:flex-1 lg:min-w-40"
          label="Hotel Name"
          value={hotelName}
          onChange={(value) => setHotelName(value || '')}
          error={error?.errors?.hotel.name}
        />

        <Input
          className="hidden lg:block lg:w-40"
          label="Trial Name"
          value={name}
          onChange={(value) => setName(value || '')}
          error={error?.errors?.name}
        />

        <Button
          className={twMerge('lg:block lg:w-auto')}
          onClick={handleSearch}
          isLoading={isLoading}
          variant="primary"
          size="large"
        >
          Search
        </Button>
      </div>
    </>
  )
}

export default Params
